import { render, staticRenderFns } from "./Detail-Template.vue?vue&type=template&id=fdcda846"
import script from "./Detail-Template.vue?vue&type=script&lang=js"
export * from "./Detail-Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports